import React, {Component} from 'react';

// Components
import Login from '../../pages/login';
import {AuthProvider} from '../../authContext';

class Auth extends Component {
  state = {};

  render() {
    const hasAuth = localStorage.getItem('token') !== null;
    const authProviderValue = {
        user: {
            role: localStorage.getItem("role") || "",
            name: localStorage.getItem("name") || "",
            warehouseId: localStorage.getItem("warehouseId") || "",
            partnerId: localStorage.getItem("partnerId") || "",
            sellerIds: localStorage.getItem("sellerIds") || ""
        }
    };
    return hasAuth ? (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    ) : (
      <Login />
    );
  }
}

export default Auth;
